export const FORM_IDENTIFIER = 'app/CreateEmployeeFormPage';

export const INIT = 'app/CreateEmployeeFormPage/INIT';
export const INIT_SUCCESS = 'app/CreateEmployeeFormPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/CreateEmployeeFormPage/INIT_FAILED';
export const SAVE = 'app/CreateEmployeeFormPage/SAVE';
export const SAVE_SUCCESS = 'app/CreateEmployeeFormPage/SAVE_SUCCESS';
export const SAVE_FAILED = 'app/CreateEmployeeFormPage/SAVE_FAILED';
